<template>
  <div class="storeBox" ref="container">
    <div
        class="storeBox-box"
        v-for="(item, index) in list"
        @click="replace(item.url,item.deptId)"
        :key="index">
      {{ item.name + '商城' }}
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getOfficialAccountList } from "@api/public";
import Loading from "@components/Loading";

export default {
  name: "Menu",
  components: { Loading },
  data: function() {
    return {
      list: [],
      loaded: false,
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
  },
  methods: {
    // 获取门店列表数据
    getList: function() {
      let _this = this;
      if (_this.loading || _this.loaded) return;
      _this.loading = true;
      const fullpath = _this.$route.fullPath;
      const deptId = fullpath.substr(
          fullpath.lastIndexOf("deptId=") + "deptId=".length
      );
      getOfficialAccountList(deptId).then(res => {
        _this.loading = false;
        _this.loaded = true;
        _this.list = res.data
      }).catch(err => {
        _this.$dialog.error(err.msg);
      });
    },
    replace(url,deptId) {
      location.href = url;
    }
  }
};
</script>
<style scoped>
.storeBox {
  width: 100%;
  background-color: #fff;
  padding: 0 0.3rem;
}
.storeBox-box {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  padding: 0.23rem 0;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
</style>
